export const configParceriasGovBR = {
  client_id: "portal-parcerias-web",
  redirect_uri: window.location.origin + "/authentication/callback",
  silent_redirect_uri:
    window.location.origin + "/authentication/silent-callback",
  scope: "openid profile",
  authority: `https://auth-crp.uat.app.sicredi.com.br/auth/realms/customercorporate`,
  authority_configuration: {
    issuer: `https://auth-crp.uat.app.sicredi.com.br/auth/realms/customercorporate`,
    authorization_endpoint: `https://auth-crp.uat.app.sicredi.com.br/auth/realms/customercorporate/protocol/openid-connect/auth`,
    token_endpoint: `https://auth-crp.uat.app.sicredi.com.br/auth/realms/customercorporate/protocol/openid-connect/token`,
    userinfo_endpoint: `https://auth-crp.uat.app.sicredi.com.br/auth/realms/customercorporate/protocol/openid-connect/userinfo`,
    end_session_endpoint: `https://auth-crp.uat.app.sicredi.com.br/auth/realms/customercorporate/protocol/openid-connect/logout`,
    check_session_iframe: `https://auth-crp.uat.app.sicredi.com.br/auth/realms/customercorporate/protocol/openid-connect/login-status-iframe.html`,
    revocation_endpoint: `https://auth-crp.uat.app.sicredi.com.br/auth/realms/customercorporate/protocol/openid-connect/token`,
  },
};

export type UserType = {
  sub: string;
  email_verified: boolean;
  cnpj: string;
  cpf: string;
  name: string;
  preferred_username: string;
  given_name: string;
  brand: string;
  email: string;
  account: string;
  organization: string;
};

/* {
  "isSicrediAssociate": false,
  "document": "48217557004",
  "hidePointsJourney": false,
  "isCompany": false
} */
